import styled from 'styled-components'

export const Content = styled.div`
  width: 100%;
  max-width: 1200px;
  position: relative;
  padding: 30px 16px 16px;
  min-height: 80vh;

  margin: 0 auto;
  .faq-top {
    margin-bottom: 20px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    @media screen and (max-width: 740px) {
      flex-direction: column;
    }

    h1.title-faq {
      font-size: 2.4rem;
      line-height: 3rem;
      color: ${({ theme }) => theme.colors.black};
    }
  }
  .search-faq {
    display: flex;

    button {
      margin-left: 15px;
    }
  }
`

export const FAQItem = styled.div`
  width: 100%;
  margin-bottom: 16px;
  transition: all 0.3s ease;
`

export const FAQHeader = styled.div<{ isExpanded: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 14px;
  border: 1px solid
    ${({ isExpanded, theme }) =>
      isExpanded ? theme.colors.gray35 : theme.colors.gray30};
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-bottom: 8px;
  &:hover {
    border-color: ${({ theme }) => theme.colors.gray35};
  }
`

export const FAQTitle = styled.h3`
  font-size: 1.2rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.black};
  margin: 0;
  flex: 1;
`

export const FAQIcon = styled.span<{ isExpanded: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s ease;
  transform: ${({ isExpanded }) =>
    isExpanded ? 'rotate(180deg)' : 'rotate(0deg)'};
  margin-left: 16px;

  img {
    width: 16px;
    height: 16px;
    filter: grayscale(100%) brightness(0.6);
  }
`

export const FAQContent = styled.div`
  padding: 20px;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  animation: slideDown 0.3s ease-out;

  @keyframes slideDown {
    from {
      opacity: 0;
      max-height: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      max-height: 200px;
      transform: translateY(0);
    }
  }
`

export const FAQText = styled.p`
  font-size: 1rem;
  line-height: 1.6;
  color: ${({ theme }) => theme.colors.grayDark};
  margin: 0;
`
